import React from 'react'
import { Text, View, useStyles } from '@ion-ui/core'
import { useMediaQuery } from 'react-responsive'
import logoIon from '../../assets/svg/logoION.svg'
import Calculator from '../Simulator/Simulator'
import { Styles } from './styles'

const AbuotUs = () => {
  const styles = useStyles(Styles)
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' })

  return (
    <View css={styles.curveBack}>
      <View css={styles.mainStyle}>
        <View css={styles.subMainStyle}>
          <View css={styles.logosStyle}>
            <img
              alt='ion'
              src={logoIon}
              css={styles.logoIon}
            />
          </View>
          <View variant='section'>
            <Text variant={!isMobile ? 'h3' : 'h4'} css={styles.title}>
              Obtener un crédito de liquidez con destino libre ahora es posible.
            </Text>
          </View>
          <Text variant='subtitle' css={styles.description}>
            Podrás disponer de $200,000 a $30 millones y pagarlos en un plazo de hasta en 20 años,
            usando tu casa o departamento como garantía de pago. 
          </Text>
        </View>
        <Calculator />
      </View>
    </View>
  )
}

export default AbuotUs
